import { useTranslation } from 'react-i18next';

import toast from '~/utils/toast';

// Pulled from: https://usehooks-ts.com/react-hook/use-copy-to-clipboard

type CopyFn = (text: string) => Promise<boolean>;

const fallbackCopy = (text: string): boolean => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    return document.execCommand('copy');
  } finally {
    document.body.removeChild(textarea);
  }
};

const useCopyToClipboard = (): CopyFn => {
  const { t } = useTranslation();

  const copy: CopyFn = async (text) => {
    try {
      if (navigator?.clipboard) {
        await navigator.clipboard.writeText(text);
      } else if (!fallbackCopy(text)) {
        throw new Error('execCommand copy failed');
      }
      toast.success(t('clipboard.success'));
      return true;
    } catch (error) {
      console.warn(t('clipboard.failure'), error);
      return false;
    }
  };

  return copy;
};

export default useCopyToClipboard;
